export default {
  authority: process.env.VUE_APP_IAM_BASE_URL,
  client_id: 'najiz-courts-2',
  redirect_uri: `${document.location.origin}/#/auth/callback`,
  response_type: 'code',
  scope: 'openid profile najiz-courts',
  post_logout_redirect_uri: `${document.location.origin}/#/auth/logout`,
  silent_redirect_uri: `${document.location.origin}/silent-renew-oidc.html`,
  automaticSilentRenew: true,
};

(() => {
  setTimeout(() => {
    Object.keys(localStorage)
      .forEach(removeOIDCFromStorage);
  }, 5000);
  window.addEventListener('storage', (e) => { removeOIDCFromStorage(e.key); }, false);
})();

const removeOIDCFromStorage = (key) => {
  if (key?.startsWith(`oidc.`) && !key?.startsWith(`oidc.user:`))
    setTimeout(() => { localStorage.removeItem(key); }, 5000);
};
